import type { CollarLog } from ".";

export const collarLogColumns: Array<{
  id: keyof CollarLog | "coordinates";
  label: string;
}> = [
  { id: "recordedAt", label: "Data e hora" },
  { id: "coordinates", label: "Coordenadas" },
  { id: "batteryLevel", label: "Bateria" },
];

export interface CollarLogWithLabels {
  id: string;
  batteryLevel: string;
  recordedAt: string;
  coordinates: string;
}
